/**
 * Transient "flash a calendar day" intent.
 *
 * Set by a chat result-card click (e.g. the onboarding therapy answer) and read
 * by the Calendar module when it opens: `useCalendarNavigation` jumps to that
 * month + month view, and `MonthView` paints the day red. In-memory only — never
 * persisted — so a full page refresh clears it; MonthView also clears it on the
 * first mouse move. Date is a `YYYY-MM-DD` string.
 */
let current: string | null = null;
const subscribers = new Set<(iso: string) => void>();

export const calendarFlash = {
  /** Request that the calendar jump to + flash this day (YYYY-MM-DD). */
  request(iso: string): void {
    current = iso;
    subscribers.forEach((fn) => fn(iso));
  },
  /** Peek the pending flash date without clearing it. */
  get(): string | null {
    return current;
  },
  /** Clear the pending flash (e.g. once the user moves the mouse). */
  clear(): void {
    current = null;
  },
  /** Subscribe to flash requests; returns an unsubscribe fn. */
  subscribe(fn: (iso: string) => void): () => void {
    subscribers.add(fn);
    return () => {
      subscribers.delete(fn);
    };
  },
};
